import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  wrapper: {
    height: "48px",
    padding: "6px 4px 3px 0",
    background: "#0f1b2a",

    "-webkit-backface-visibility": "hidden",
  },
  navigation: {
    display: "flex",
    justifyContent: "end",
    height: "100%",
    overflow: "hidden",
  },
  nav: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "40px",
    borderRadius: "8px 8px 0 0",
    color: "#d1d5db",
    cursor: "pointer",
    padding: "4px 0px 8px",
    marginTop: "4px",
    "&.inactive": {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    "&.active": {
      zIndex: 1,

      background: "#fff",
      color: "#077398",
      cursor: "default",
      pointerEvents: "none",
      "& $nav_bottom": {
        display: "block",
      },
    },
  },
  nav_icon: {
    display: "block",
    position: "relative",
    zIndex: 3,
    "& svg": {
      display: "block",
    },
  },
  nav_bottom: {
    display: "none",
    position: "absolute",
    height: "4px",
    width: "36px",
    bottom: "2px",
    background: "#077398",
    borderRadius: "20px",
    "&::after, &::before": {
      content: '""',
      display: "block",
      position: "absolute",
      bottom: 0,
      border: "6px solid transparent",
    },
  },
}));
